import { Box, Stack } from '@mui/material'
import { Children } from 'react'

interface TabPaneProps {
  value: number
  index: number
  children: any
}

const TabPanel = (props: TabPaneProps) => {
  return (
    <Box
      role='tabpanel'
      hidden={props.value !== props.index}
      id={`simple-tabpanel-${props.index}`}
      aria-labelledby={`simple-tab-${props.index}`}
      sx={{ height: '100%' }}
    >
      {props.value === props.index && (
        <Box sx={{ height: '100%' }}>{props.children}</Box>
      )}
    </Box>
  )
}

const RenderChild = (children: any, selectedTabIndex: number) => {
  return Children.map(children, (child: any, index: number) => {
    return (
      <TabPanel value={selectedTabIndex} index={index}>
        {child}
      </TabPanel>
    )
  })
}

const TabContent = (props: any) => {
  const { children, selectedTabIndex, contentHeight } = props

  return (
    <Stack sx={{ height: contentHeight ? contentHeight : '90%' }}>
      {RenderChild(children, selectedTabIndex)}
    </Stack>
  )
}

export default TabContent
